const CONSTANTS = require('frontend-controller/lib/constants');
module.exports = {
	model: {
		entityTable: false,

		ninjaModule: '',            // actual ninjaModule (e.g., events)
		ninjaModuleConfig: {},      // actual ninjaModuleConfig defined by web-projects clientAppConfig (e.g., appConfig.ninjaModules.events)
		ninjaModuleSubConfig: {},   // actual ninjaModuleSubConfig defined by web-projects clientAppConfig (e.g., appConfig.ninjaModules.events.entityPart.coreInformation)

	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				if($target.length > 0){
					var fieldType = $target.data('fieldType');
					if(self.model.entityTable){
						if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						} else if(fieldType === 'export'){
							self.model.entityTable.export()
						}
					}
				}
			}
		}
	},

	methods: {
		isBuildGranted(storage){
			if(storage.isServer){
				return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES
			}

			this.closest('templates_ninja_controller', controller => {
				this.model.ninjaModule = controller.model.ninjaModule
				this.model.ninjaModuleConfig = controller.model.ninjaModuleConfig
			}, true)

			const ninjaModuleConfig = this.model.ninjaModuleConfig || {}
			const ninjaModuleSubConfig = this.model.ninjaModuleSubConfig = (ninjaModuleConfig.entity || {}).participants

			if(ninjaModuleSubConfig){
				const turnedOn = ninjaModuleConfig.turnedOn && ninjaModuleSubConfig.turnedOn

				if(turnedOn){
					return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES
				}
			} else {
				console.error(`ninjaModuleSubConfig missing: frontend-controller/client/appConfig.js ninjaModules.${this.model.ninjaModule}.entity.participants`)
			}

			this.closest('base_tabStrip_tabContent', tabContent => {
				tabContent.close()
			})

			return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.NO
		},
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.entityTable){
				self.find('base_tableSimple_table', function(entityTable){
					self.model.entityTable = entityTable;
				});
			}
		},

		filtersChanged: function ($element, options) {
			this.triggerFind('filtersChanged', options);
		},

		filterColumnsChanged: function ($element, options) {
			this.triggerFind('filterColumnsChanged', options);
		},

		colTagsBubbleSelected: function($element, options){
			this.triggerFind('colTagsBubbleSelected', options);
		},

		showColumnDescription: function ($element, options) {
			this.triggerFind('showColumnDescription', options);
		},

		hideColumnDescription: function ($element, options) {
			this.triggerFind('hideColumnDescription', options);
		}
	}
};